<div cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)" class="preview-container">
  <!-- Placeholder pour ajouter plus d'images - affiché en premier -->
  <div *ngIf="filesUrl && filesUrl.length > 0" class="add-more-wrapper">
    <div class="add-more-placeholder">
      <div class="placeholder-icon">
        <i class="bi bi-plus-lg"></i>
        <i class="bi bi-image-alt"></i>
      </div>
      <span class="placeholder-text">{{'dz_add_more' | translate}}</span>
    </div>
  </div>

  <div *ngFor="let f of filesUrl; let fileIndex = index" cdkDrag [cdkDragDisabled]="!allowReorder || f.loading">
    <div class="img-wrapper clickable-preview" (click)="openFile($event, fileIndex)">
      <!-- Image Preview -->
      <img *ngIf="!f.loading && f.url && isImage(f.url) && !isBroken(f.url)" [src]="f.url" class="img" alt="preview-img"
        [ngStyle]="getImageStyles()" (error)="onImageError(f.url)">

      <!-- El fichero ya no existe en el servidor: placeholder en vez del icono roto del navegador.
           El boton de borrar de mas abajo se sigue mostrando encima. -->
      <div *ngIf="!f.loading && f.url && isImage(f.url) && isBroken(f.url)"
        class="file-preview-content file-preview-content--broken">
        <i class="bi bi-image-alt"></i>
        <span class="file-name">{{ 'ml_media_unavailable' | translate }}</span>
      </div>

      <!-- Non-Image File Preview (PDF, etc) -->
      <div *ngIf="!f.loading && f.url && !isImage(f.url)" class="file-preview-content">
        <i class="bi bi-file-earmark-text"></i>
        <span class="file-name">{{ f.url.split('/').pop() }}</span>
      </div>

      <span *ngIf="f.loading" class="spinner-border text-light" role="status" aria-hidden="true"></span>

      <!-- AI Enhancement button - centered on image -->
      <button *ngIf="!f.loading && f.url && isImage(f.url) && !isBroken(f.url)" class="ai-enhance-btn" type="button"
        (click)="enhanceWithAI($event, fileIndex)" title="{{ 'ai_improve' | translate }}">
        <i class="bi bi-magic"></i>
      </button>

      <ngx-dropzone-remove-badge *ngIf="!f.loading" (click)="removeImage($event, fileIndex)">
      </ngx-dropzone-remove-badge>
      <!-- Cancel button during loading - same style as remove badge -->
      <ngx-dropzone-remove-badge *ngIf="f.loading" (click)="cancelUpload($event, fileIndex)">
      </ngx-dropzone-remove-badge>
    </div>
  </div>
</div>

<ng-content select="ngx-dropzone-label"></ng-content>

<div *ngIf="!filesUrl">
  <div class="single-img-wrapper clickable-preview" (click)="openFile($event, 0)">
    <!-- Single Image Preview -->
    <img *ngIf="singleFileUrl && singleFileUrl.value && isImage(singleFileUrl.value) && !isBroken(singleFileUrl.value)"
      [src]="singleFileUrl.value" class="single-img" alt="preview-img" [ngStyle]="getImageStyles()"
      [title]="getImageInfo()" (error)="onImageError(singleFileUrl.value)">

    <!-- El fichero ya no existe en el servidor. La remove-badge de mas abajo se sigue mostrando. -->
    <div *ngIf="singleFileUrl && singleFileUrl.value && isImage(singleFileUrl.value) && isBroken(singleFileUrl.value)"
      class="file-preview-content single file-preview-content--broken">
      <i class="bi bi-image-alt"></i>
      <span class="file-name">{{ 'ml_media_unavailable' | translate }}</span>
    </div>

    <!-- Single Non-Image File Preview -->
    <div *ngIf="singleFileUrl && singleFileUrl.value && !isImage(singleFileUrl.value)"
      class="file-preview-content single">
      <i class="bi bi-file-earmark-text"></i>
      <span class="file-name">{{ singleFileUrl.value.split('/').pop() }}</span>
    </div>

    <span
      *ngIf="!singleFileUrl || (singleFileUrl && !singleFileUrl.value && !isImage(singleFileUrl.value)) && !singleFileUrl.value"
      class="spinner-border text-light" role="status" aria-hidden="true"></span>

    <ngx-dropzone-remove-badge *ngIf="singleFileUrl?.value" (click)="removeImage($event, 0)" class="bg-light-primary">
    </ngx-dropzone-remove-badge>
  </div>
</div>